import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMapStore = defineStore('map', () => {

    const showMap = ref(true);

    const showSearchButton = ref(false);

    const disableMapMoveEvent = ref(false);

    function toggleShowMap() {

        showMap.value = !showMap.value;

    }

    function setShowSearchButton(value) {

        showSearchButton.value = value;

    }

    function setDisableMapMoveEvent(value) {

        disableMapMoveEvent.value = value;

    }

    return {
        showMap,
        toggleShowMap,
        showSearchButton,
        setShowSearchButton,
        disableMapMoveEvent,
        setDisableMapMoveEvent,
    }

})
